import { FC } from 'react';

// Components
import WinnerBadge from './WinnerBadge';
import Image from '../../../../../../packages/HOC/AccessibilityImage';

// Types
import { INormalizedTeamV2 } from '../../../../../../packages/types';
import { classNames } from '@sportal365/smp-widget-utils';
import { TEAM_ENTITY } from '../../../../../../packages/constants/entityTypes';

interface Props {
  homeTeam: INormalizedTeamV2;
  awayTeam: INormalizedTeamV2;
  startTime: string;
  score: string;
}

const MatchParticipantsHorizontal: FC<Props> = ({ homeTeam, awayTeam, score, startTime }) => {
  return (
    <div className='match-participants-horizontal-container grid gap-2 justify-center items-center grid-cols-[1fr_40px_1fr] py-4 pr-4'>
      <div className='home-team-container flex justify-end items-center gap-2 overflow-hidden'>
        {homeTeam.winnerReason ? <WinnerBadge text={homeTeam.winnerReason} /> : null}
        <p
          className={classNames({
            'home-team-name m-0 text-4 text-hiContrast whitespace-nowrap overflow-hidden text-ellipsis max-w-full': true,
            'font-bold': homeTeam.isWinner,
          })}
        >
          {homeTeam.name}
        </p>

        <Image src={homeTeam.logo} alt={homeTeam.name} entityType={TEAM_ENTITY} className='home-team-logo h-7 w-7 shrink-0' />
      </div>
      <div
        className={classNames({
          'flex justify-center items-center h-[30px] text-4': true,
          'text-primaryGray': startTime || score === '-',
          'text-hiContrast': !startTime || score !== '-',
        })}
      >
        {startTime ? <span className='match-start-time'>{startTime}</span> : <span className='match-score'>{score}</span>}
      </div>
      <div className='away-team-container flex justify-start items-center gap-2 overflow-hidden'>
        <Image src={awayTeam.logo} alt={awayTeam.name} entityType={TEAM_ENTITY} className='away-team-logo h-7 w-7 shrink-0' />
        <p
          className={classNames({
            'away-team-name m-0 text-4 text-hiContrast overflow-hidden whitespace-nowrap text-ellipsis max-w-full': true,
            'font-bold': awayTeam.isWinner,
          })}
        >
          {awayTeam.name}
        </p>
        {awayTeam.winnerReason ? <WinnerBadge text={awayTeam.winnerReason} /> : null}
      </div>
    </div>
  );
};

export default MatchParticipantsHorizontal;
